import React from "react";
import PostDetailUpdate from "../components/postDetail/PostDetailUpdate";

const PostUpdate = () => {
  return (
    <div>
      <PostDetailUpdate />
    </div>
  );
};

export default PostUpdate;
